import { compareRows as defaultCompareRows } from "../../types";
import { defaultMultiFilter } from "../../types/GridColumnProps";
import { getCellDisplayValue } from "../DataGrid/DataGridColumnDefinition";
// #region Convert column definitions to react-table column definitions
export const convertColumnDefinitions = (columnDefs) => {
    const columns = [];
    columnDefs.forEach(({ columnName, isVisible, isDataProperty, isGrouped, groupHeaderRow, path, allowSort, sortComparer, columns: defColumns, Cell, id, width, filter, ...other }) => {
        //The compiler won't let accessor accept a property that is of multiple types, hence the if statement below.
        let accessorObject;
        let pathString = "";
        if (path) {
            if (typeof path == "string") {
                pathString = path;
                accessorObject = { accessor: pathString };
            }
            else {
                const pathFunc = path;
                accessorObject = { accessor: pathFunc };
            }
        }
        else {
            accessorObject = { accessor: "" };
        }
        return columns.push({
            Cell: Cell ||
                ((cellProps) => {
                    return getCellDisplayValue(cellProps.cell.value);
                }),
            columns: defColumns && convertColumnDefinitions(defColumns),
            defaultCanFilter: true,
            disableSortBy: allowSort == false,
            sortType: sortComparer ?? defaultCompareRows,
            filter: filter ?? defaultMultiFilter,
            groupHeaderRow: groupHeaderRow,
            Header: columnName,
            id: id || pathString,
            isGrouped: isGrouped || false,
            isDataProperty: isDataProperty ?? true,
            isVisible: typeof isVisible !== "undefined" ? isVisible : true,
            pxWidth: width,
            ...accessorObject,
            ...other
        });
    });
    return columns;
};
// #endregion
